export { default as BaseTemplate } from './BaseTemplate'
export { default as FullTextTemplate } from './FullTextTemplate'
export { default as IntroTemplate } from './IntroTemplate'
export { default as SingleVideoTemplate } from './SingleVideoTemplate'
export { default as SliderTemplate } from './SliderTemplate'
export { default as SocialTemplate } from './SocialTemplate'
export { default as SuggestTemplate } from './SuggestTemplate'
export { default as VideoTemplate } from './VideoTemplate'


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/index.js